import script from "./SuspiciousIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./SuspiciousIndex.vue?vue&type=script&setup=true&lang=js"

import "./SuspiciousIndex.vue?vue&type=style&index=0&id=f8c69cea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8c69cea"]])

export default __exports__